//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 06/10/2025
// Version       : 1
// Description   : Activar/Anular tipos para vehiculos
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  Snackbar,
} from "@mui/material";

//Notification
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CambiarEstadoTipo(props) {
  const isTipoActivo = props.tipo.estado === 1;

  // Deshabilitar Botón
  const [disBtn, setDisBtn] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // ------------------------------------------------------------------

  // FUNCIONES PARA GUARDAR EL ESTADO DE LOS TIPOS
  const guardarActivo = async () => {
    await fetch(
      UrlApi + "/tipos_vehiculos2/" + encodeURIComponent(props.tipo.id),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 1, // Activar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El tipo se activó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al activar el tipo");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const guardarInactivo = async () => {
    await fetch(
      UrlApi + "/tipos_vehiculos2/" + encodeURIComponent(props.tipo.id),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 2, // Desactivar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El tipo se desactivó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al desactivar el tipo");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // -------------------------------------

  // Manejar el guardado de estado
  const handleGuardarEstado = () => {
    if (isTipoActivo) {
      setDisBtn(true);
      guardarInactivo(props.tipo); // Si está activo, lo desactiva
    } else {
      setDisBtn(true);
      guardarActivo(props.tipo); // Si está inactivo, lo activa
    }
  };

  //*************************************************************************************************************************************/

  // Snackbar Notificacion
  // Cerrar el Snackbar y finalizar
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setDisBtn(false);
    setOpenSnack(false);

    // Acciones de cierre de diálogo y actualización después de que el Snack se cierre
    props.onTipoGuardado(); // Función para obtener valores de nuevo en el componente padre
    props.handleCloseCambiarEstadoTipo();
  };

  return (
    <>
      <Box
        style={{
          borderWidth: 2,
          borderStyle: "solid",
          border: "2px solid #2B76A6",
        }}
      >
        <DialogTitle sx={{ padding: 0, marginBottom: 2 }}>
          <Box
            sx={{
              backgroundColor: "#2B76A6",
              width: "100%",
              padding: "8px 0",
              textAlign: "center",
            }}
          >
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              {isTipoActivo ? "ANULAR" : "ACTIVAR"} TIPO DE VEHÍCULO
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography align="center">{props.tipo.nombre}</Typography>
        </DialogContent>
        <Typography align="center" sx={{ fontWeight: "bold" }}>
          {isTipoActivo
            ? "¿Desea anular este tipo?"
            : "¿Desea activar este tipo?"}
        </Typography>
        <DialogActions>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              color="error"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={props.handleCloseCambiarEstadoTipo}
              disabled={disBtn}
            >
              Volver
            </Button>
            <Button
              variant="contained"
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                fontWeight: 600,
              }}
              onClick={handleGuardarEstado}
              disabled={disBtn}
            >
              {isTipoActivo ? "Anular" : "Activar"}
            </Button>
          </Box>
        </DialogActions>
      </Box>

      {/* SNACKBAR QUE SE MOSTRARÁ AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CambiarEstadoTipo;
